export enum ConfigParamsEnum {
  AGREEMENTS = 'agreements',
  TID = 'tinkoffID',
}

export enum ConfigValuesEnum {
  AGREEMENTS_OPEN = 'open',
  AGREEMENTS_CLOSE = 'close',
  AGREEMENTS_BY_TIME = 'by_time', // отображение по времени с 5:00 до 7:00 и с 21:00 до 23:00 (МСК)
}
